import TalentEngineSave from 'components/marketingSite/talentEngineV3/pages/TalentEngineSave';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type TalentEngineSaveProps = WithBaseUrl;

const TalentEngineSavePage: React.FC<TalentEngineSaveProps> = ({ baseUrl }) => {
  const { t } = useI18n('talent-engine-save');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('talent-engine-save.page_title')}
        url={APP_URLS.talentEngineSave}
        desc={t('talent-engine-save.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_talent_engine.png'
        )}`}
        indexable={true}
      />
      <TalentEngineSave />
    </>
  );
};

export default TalentEngineSavePage;

export const getStaticProps: GetStaticProps<TalentEngineSaveProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-engine-save',
        'talent-engine-landing-v3'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
